(async () => {
  if (!customElements.get("image-link-carousel")) {
    const { default: Swiper, Navigation, Autoplay } = await import("swiper");

    Swiper.use([Navigation, Autoplay]);

    class ImageSlider extends HTMLElement {
      constructor() {
        super();

        this.swiperElement = this.querySelector("[data-swiper]");
        this.swiperOptions = {
          direction: "horizontal",
          loop: false,
          threshold: 10,
        };

        // Check if we have extra options on the HTML
        if (this && this.dataset && this.dataset.options) {
          const jsonOptions = JSON.parse(this.dataset.options);
          if (jsonOptions) {
            this.swiperOptions = {
              ...this.swiperOptions,
              ...jsonOptions,
            };
          }
        }

        this.swiperInstance = new Swiper(
          this.swiperElement,
          this.swiperOptions
        );

        // re-init slider when Theme Editor is active
        if (Shopify.designMode && this.swiperInstance) {
          window.addEventListener("shopify:section:load", () => {
            this.swiperInstance.update();
          });
        }
      }
    }
    window.imageSlider = ImageSlider;
    customElements.define("image-link-carousel", ImageSlider);
  }
})();
